import { Injectable } from '@angular/core';
import { TimeProvider } from '../time/time';
import { Subscription } from 'rxjs';

/**
 * 定期実行処理を管理するプロバイダー.
 */
@Injectable()
export class IntervalProvider {

  constructor(public timer: TimeProvider) { }

  /**
   * 定期実行処理を開始する.
   * @param intervalSeconds 実行間隔(秒単位)
   * @param callback 実行処理
   * @returns 定期実行処理のサブスクリプション
   */
  public subscribe(intervalSeconds: number, callback: (seconds: number) => void): Subscription {
    return this.timer.elapsedSeconds.subscribe((elapsedSeconds) => {
      if (elapsedSeconds < intervalSeconds) {
        return;
      }

      if (elapsedSeconds % intervalSeconds !== 0) {
        return;
      }

      callback(elapsedSeconds);
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/interval/interval.ts